import { FC } from 'react';
import { Box, Link } from '@chakra-ui/react';
import {
  refusalReasonsLocales as libRefusalReasonsLocales,
  SHINE_START_REFUSAL_REASONS,
} from '@shinetools/shine-start-library';
import LocalizedStrings from 'localized-strings';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import OpenHelpButtonLink from 'features/Help/components/OpenHelpButtonLink';
import ApplicationProblemImage from 'features/Onboarding/components/ApplicationProblemImage';

import Page from '../../components/Page';
import locales from './locales';
import { ComponentProps } from './types';

const UNSUPPORTED_JOBS_LINK =
  'https://help.shine.fr/fr/articles/3606432-quelles-sont-les-activites-que-shine-n-accepte-pas';

const refusalReasonsLocales = new LocalizedStrings(libRefusalReasonsLocales);

const getRefusalDescription = (
  refusalReasonCode: ComponentProps['refusalReasonCode'],
) => {
  if (refusalReasonCode === SHINE_START_REFUSAL_REASONS.UNSUPPORTED_JOB) {
    return (
      <>
        {locales.unsupportedJob.description}
        <Link href={UNSUPPORTED_JOBS_LINK} isExternal marginTop="space-16">
          {locales.unsupportedJob.linkLabel}
        </Link>
      </>
    );
  }

  return refusalReasonCode !== null &&
    refusalReasonCode in refusalReasonsLocales
    ? `${refusalReasonsLocales[refusalReasonCode].label}\n\n${locales.pleaseContactUs}`
    : locales.pleaseContactUs;
};

const ShineStartBusinessInfoRefused: FC<ComponentProps> = ({
  refusalReasonCode,
}) => (
  <Page withNoBackButton>
    <Box>
      <ApplicationProblemImage />

      <Heading marginBottom="space-16" size="lg">
        {locales.title}
      </Heading>

      <Text marginBottom="space-32" variant="primary">
        {getRefusalDescription(refusalReasonCode)}
      </Text>

      <OpenHelpButtonLink isExpanded>
        {locales.findOutMoreLink}
      </OpenHelpButtonLink>
    </Box>
  </Page>
);

export default ShineStartBusinessInfoRefused;
